import { defineExperiment } from '@cian/experiments/ab';
import { NEWBUILDING_BOOKING_AUTH_EXPERIMENT } from 'shared/services/abUseExperiments/experiments';

export const NewbuildingBookingAuthExperiment = defineExperiment(NEWBUILDING_BOOKING_AUTH_EXPERIMENT, {
  groups: ['A', 'B'] as const,
  default: 'A',
});
